import React from 'react';
import isoLogo from '../assets/iso-soc-logo-1.svg';
import icon1 from '../assets/WhyUs-icon-1.svg';
import icon2 from '../assets/WhyUs-icon-2.svg';
import icon3 from '../assets/WhyUs-icon-3.svg';
import icon4 from '../assets/WhyUs-icon-4.svg';

const WhyUs = () => {
    return (
        <section className="w-full bg-[#070E21] py-20 px-4 md:px-8 text-white">
            <div className="max-w-[1272px] mx-auto">
                {/* Header */}
                <div className="text-center mb-16">
                    <h2 className="font-oswald text-3xl md:text-6xl font-bold uppercase mb-4 tracking-wider">
                        WHY US
                    </h2>
                    <p className="font-inter text-gray-400 text-lg md:text-xl">
                        Institutional expertise meets modern SaaS delivery
                    </p>
                </div>

                {/* Bento Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                    {/* Row 1 */}
                    {/* Box 1 (Wide ~730px -> ~7 cols) */}
                    <div className="lg:col-span-6 bg-[#0E1527] border border-gray-700 rounded-[4px] p-8 md:p-10 flex flex-col justify-start min-h-[295px]">
                        <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-6">
                            <img src={icon1} alt="Icon 1" loading="lazy" />
                        </div>
                        <h3 className="font-inter text-2xl md:text-[28px] font-bold mb-4 leading-tight">
                            30+ Years Building Mission-Critical Trading Systems
                        </h3>
                        <p className="font-inter text-gray-300 text-[14px] leading-[1.5] font-normal">
                            Our team has designed and operated mission-critical platforms in New York, London, and beyond. Trillions of dollars' worth of transactions have been executed by global financial institutions on systems built by us.
                        </p>
                    </div>

                    {/* Box 2 (Narrow ~514px -> ~5 cols) */}
                    <div className="lg:col-span-6 bg-[#0E1527] border border-gray-700 rounded-[4px] p-8 md:p-10 flex flex-col justify-start min-h-[295px] relative">
                        {/* ISO Logo - Positioned top-right */}
                        <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-6">
                            <img src={icon2} alt="Icon 2" loading="lazy" />
                        </div>
                        <h3 className="font-inter text-2xl md:text-[28px] font-bold mb-4 leading-tight">
                            ISO27001 & SOC2 Certified
                        </h3>
                        <div className="">
                            <img src={isoLogo} alt="ISO & SOC Certified" className="h-12 md:h-16 w-auto" loading="lazy" />
                        </div>
                    </div>

                    {/* Row 2 */}
                    {/* Box 3 (Narrow ~406px -> ~4 cols) */}
                    <div className="lg:col-span-6 bg-[#0E1527] border border-gray-700 rounded-[4px] p-8 md:p-10 flex flex-col justify-start min-h-[295px]">
                        <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-6">
                            <img src={icon3} alt="Icon 3" loading="lazy" />
                        </div>
                        <h3 className="font-inter text-2xl md:text-[28px] font-bold mb-4 leading-tight">
                            US-Based Success Hub
                        </h3>
                        <p className="font-inter text-gray-300 text-[14px] leading-[1.5] font-normal">
                            Discovery, oversight, and relationship management from our US team ensures alignment with your business needs.
                        </p>
                    </div>

                    {/* Box 4 (Wide ~840px -> ~8 cols) */}
                    <div className="lg:col-span-6 bg-[#0E1527] border border-gray-700 rounded-[4px] p-8 md:p-10 flex flex-col justify-start min-h-[295px]">
                        <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-6">
                            <img src={icon4} alt="Icon 4" loading="lazy" />
                        </div>
                        <h3 className="font-inter text-2xl md:text-[28px] font-bold mb-4 leading-tight">
                            Global R&D Center in India
                        </h3>
                        <p className="font-inter text-gray-300 text-[14px] leading-[1.5] font-normal">
                            24×5 monitoring, engineering, and support. Round-the-clock coverage for mission-critical operations.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyUs;
